module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/instruments/icon_8d2737bf44c18e19a9a79dfe1215cb53.png";